import fetch from 'isomorphic-fetch';
import {BASE_URL} from '../urls';

const RESPONSES_ENDPOINT = `${BASE_URL}/responses`;
const ALL_RESPONSES_ENDPOINT = `${BASE_URL}/responses/all`;

export const FETCH_RESPONSES = "FETCH_RESPONSES";
export const FETCH_NEXT_RESPONSES_PAGE = "FETCH_NEXT_RESPONSES_PAGE";
export const PREV_RESPONSES_PAGE = "PREV_RESPONSES_PAGE";
export const NEXT_RESPONSES_PAGE = "NEXT_RESPONSES_PAGE";
export const FETCHED_RESPONSES = "FETCHED_RESPONSES";
const PAGE_SIZE = 12;

export function fetchNextResponsesPage() {
  return (dispatch, getState) => {
    const { pages, currentCursor, fetching } = getState().responses.allResponses;
    const page = pages[currentCursor];
    const nextCursor = page ? page.nextCursor : null;
    const nextPage = nextCursor ? pages[nextCursor.id] : null;
    if (!fetching) {
      if (nextPage) {
        dispatch({
          type: NEXT_RESPONSES_PAGE
        });
      } else if (nextCursor || !page) {
        dispatch({
          type: FETCH_NEXT_RESPONSES_PAGE,
          cursor: nextCursor
        });
        let token = getState().auth.token;
        let opts = {
          headers: {
            Authorization: token
          }
        }
        return fetch(`${ALL_RESPONSES_ENDPOINT}?cursor=${nextCursor ? btoa(JSON.stringify(nextCursor)) : ''}&limit=${PAGE_SIZE}`, opts)
          .then((data) => {
            return data.json()
              .then((json) => {
                dispatch({
                  type: FETCHED_RESPONSES,
                  payload: json,
                  cursor: nextCursor,
                  pageSize: PAGE_SIZE
                });
                Promise.resolve();
              });
          });
      }
    }
  }
}

export function previousResponsesPage() {
  return (dispatch, getState) => {
    const { pages, currentCursor, fetching } =  getState().responses.allResponses;
    const currentPage = pages[currentCursor];
    if (currentPage.min > 1 && !fetching) {
      dispatch({
        type: PREV_RESPONSES_PAGE
      });
    }
  }
}

export const FETCHING_RESPONSE = "FETCHING_RESPONSE";
export const FETCHED_RESPONSE = "FETCHED_RESPONSE";

export function fetchResponse(id) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCHING_RESPONSE
    });
    return fetch(RESPONSES_ENDPOINT + "/" + id)
      .then((data) => {
        return data.json()
          .then((json) => {
            dispatch({
              type: FETCHED_RESPONSE,
              payload: json
            });
            Promise.resolve();
          });
      });
  }
}

export const fetchReadOnlyResponse = fetchResponse;

export const FETCHED_OWN_RESPONSES = 'FETCHED_OWN_RESPONSES';
const OWN_RESPONSES_ENDPOINT = `${BASE_URL}/responses`;

export function fetchOwnResponses(callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_RESPONSES
    });
    let token = getState().auth.token;
    let opts = {
      headers: {
        Authorization: token
      }
    }
    return fetch(OWN_RESPONSES_ENDPOINT, opts)
      .then((data) => {
        return data.json()
          .then((json) => {
            dispatch({
              type: FETCHED_OWN_RESPONSES,
              payload: json
            });
            Promise.resolve();
            if (callback) {
              callback();
            }
          });
      });
  }
}

export function copyResponse(id, attributes, next) {
  return (dispatch, getState) => {
    fetch(`${BASE_URL}/responses/${id}/copy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getState().auth.token,
      },
      body: JSON.stringify(attributes)
    }).then(() => {
      next();
    });
  }
}

export const DELETE_RESPONSE = 'DELETE_RESPONSE';
export function deleteResponse(id, createdAt){
  return (dispatch, getState) => {
    fetch(`${BASE_URL}/responses/${id}/delete/${createdAt}`, {
      method: "DELETE",
      headers: {
        Authorization: getState().auth.token,
      }
    }

  ).then((data) => {
      if(data.status === 200){
        dispatch({
          type:DELETE_RESPONSE,
          id
        })
      } else {
        alert("Server Error when deleting: " + data.status + " " + data.statusText)
      }
     })
  }
}
